import { ArrowDropDown } from '@mui/icons-material'
import { Button } from '@mui/material'
import React from 'react'

const ButtonTriggerFilter = ({
    id,
    open,
    setAnchorEl,
    startIcon,
    endIcon,
    label,
    mr = 3
}) => {
    return (
        <Button
            variant='text'
            id={id}
            aria-controls={open ? 'view-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={e => setAnchorEl(e.currentTarget)}
            startIcon={startIcon}
            endIcon={endIcon || <ArrowDropDown />}
            sx={(theme) => ({
                color: theme.palette.text.primary,
                mr: mr,
                fontWeight: 600,
                border: theme => `1px solid ${theme.palette.text[50]}`,
                backgroundColor: '#FFF',
                padding: '5px 1em',
                maxHeight: '36px',
                '&:hover': {
                    borderColor: theme.palette.secondary.light,
                    backgroundColor: theme.palette.text[50]
                },
            })}
        >
            {label}
        </Button>
    )
}

export default ButtonTriggerFilter